(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vm-custom-tab-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {

  /* OPEN MENU */
  document.querySelector('.desktop-nav-toggle')?.addEventListener('click', () => {
    document.querySelectorAll('.vm-custom-tab-menu').forEach(menu => {
      menu.classList.add('is-active');
    });
  });

  /* INIT TAB LOGIC */
  document.querySelectorAll('.vm-custom-tab-menu').forEach(menu => {

    const tabs = menu.querySelectorAll('.vm-tab-des');
    const panels = menu.querySelectorAll('.vm-panel-des');
    const closeBtn = menu.querySelector('.vm-desktop-close');

    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const target = this.dataset.tab;

        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));

        this.classList.add('active');
        menu.querySelector(`[data-panel="${target}"]`)?.classList.add('active');
      });
    });

    closeBtn?.addEventListener('click', () => {
      menu.classList.remove('is-active');
    });

  });

});
  } catch(e) { console.error(e); }
})();

})();
